import axios from 'axios';
import { getConfig } from 'config';
import qs from 'qs';

import { COMPANY } from 'models/company.model';

const axiosInstance = axios.create({
  paramsSerializer: (params) =>
    qs.stringify(params, { indices: false, encode: false, allowDots: true }),
});

export const changeAxiosUrl = (
  company = localStorage.getItem('company') as COMPANY | undefined
) => {
  if (company) {
    const userDetails = getConfig(company);
    axiosInstance.defaults.baseURL = `${userDetails.baseUrl}/v1.0`;
  }
};

export const updateAxiosHeader = () => {
  axiosInstance.defaults.headers.common['Authorization'] = localStorage.getItem('JWTToken') || '';
};

export default axiosInstance;
